import LocalStorageService from './LocalStorageService';

export default LocalStorageService;
